// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../graphql/api/index';

import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const WarrantyActivationDocument = `
    query warrantyActivation($id: ID!) {
  warrantyActivated(id: $id)
}
    `;

export function useWarrantyActivationQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.WarrantyActivationQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.WarrantyActivationQuery, SchemaTypes.WarrantyActivationQueryVariables | undefined>({ query: WarrantyActivationDocument, variables: undefined, ...options });
};
export const ActivateWarrantyDocument = `
    mutation activateWarranty($input: ActivateWarrantyInput!) {
  activateWarranty(input: $input)
}
    `;

export function useActivateWarrantyMutation() {
  return Urql.useMutation<SchemaTypes.ActivateWarrantyMutation, SchemaTypes.ActivateWarrantyMutationVariables>(ActivateWarrantyDocument);
};